import React, { useState } from "react";
import styled from "@emotion/styled";
import Modal from "./Modal";
import InputWithLabel from "./InputWithLabel";
import Button from "./Button";
import { api } from "../utils/api";
import auth from "../utils/auth";

/**
 * 휴대폰 번호 등록(문자 인증). 카드 자동결제는 휴대폰 번호가 있어야 시작되므로(서버 /billing/start),
 * 번호 없는 회원(카카오·구글 가입 등)은 카드 등록창을 열기 전에 먼저 받는다.
 */
const PhoneCertModal: React.FC<{ onClose: () => void; onDone: () => void }> = ({ onClose, onDone }) => {
  const [info, setInfo] = useState({ phone: "", phoneCert: "" });
  const [sent, setSent] = useState(false);
  const [count, setCount] = useState(1);

  const handleChange = (e: any) => {
    e.persist();
    setInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const sendCert = async () => {
    if (count > 2) {
      alert("3회 이상 시도하셨습니다. 잠시 후 다시 시도해주세요.");
      return;
    }
    if (!info.phone) return;
    const { data } = await api.post("/sms/certification", { phone: info.phone });
    if (data.success) {
      setCount(count + 1);
      setSent(true);
    }
  };

  const confirm = async () => {
    const { data } = await api.post("/phone/change", { phone: info.phone, phoneCert: info.phoneCert });
    if (data.success) {
      auth.setPhone(info.phone);
      onDone();
    } else {
      alert(data.alert);
    }
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      firstButtonLabel="확인"
      onClickFirstButton={confirm}
      title="휴대폰 번호 등록"
      content={
        <InputWrap>
          구독을 시작하려면 휴대폰 번호 등록이 필요해요.
          <br />
          결제 안내를 이 번호로 보내 드려요.
          <InputWithLabel
            name="phone"
            label="휴대폰 번호"
            placeholder="휴대폰 번호를 입력해주세요."
            maxLength={11}
            onChange={handleChange}
          />
          {sent && (
            <InputWithLabel
              name="phoneCert"
              label="인증 번호"
              placeholder="인증 번호를 입력해주세요."
              maxLength={10}
              onChange={handleChange}
            />
          )}
          <Button styleType="blue" onClick={sendCert}>
            {sent ? "인증번호 재발송" : "휴대폰인증"}
          </Button>
        </InputWrap>
      }
    />
  );
};

export default PhoneCertModal;

const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  & > * {
    margin-bottom: 20px;
  }
`;
